module.exports = __webpack_public_path__ + "static/logopurple-8f69615086ee51cec4254728b122ad07.svg";